import loadingTemplate from './loadingTemplate';
import { theme } from '../constants/defaults';
import { normalizeProductItem } from '../utils/product';
import cartModalItemTemplate from './cartModalItemTemplate';
import { renderFooter, renderNote } from './cartModalFooterTemplate';

export default function(isLoading, state) {
  if (isLoading) {
    return loadingTemplate();
  }

  const { item_count: itemCount, items, note } = state;

  if (itemCount === 0) {
    return `
      <p>${theme.strings.cart_empty}</p>
      <button class="button js-modal-close">
        ${theme.strings.cart_continue_shopping}
      </button>
    `;
  }

  const itemsList = items.map(item => {
    const itemObject = normalizeProductItem(item);
    return cartModalItemTemplate(itemObject);
  });

  return `
    <form action="${theme.routes.cart}" method="post" novalidate class="ajaxcart">
      <div class="ajaxcart__inner">
        ${itemsList.join('')}
        ${renderNote(note)}
      </div>

      ${renderFooter(state)}
    </form>
  `;
}
